import { dev } from "../../../dev"

export const logosEmailAttachments = [
  {
    filename: "vzdelanibudoucnosti-logo.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/vzdelanibudoucnosti_2_black_text.png`,
    cid: "vzdelanibudoucnosti-logo"
  },
  {
    filename: "facebook-logo.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/facebook-logo.png`,
    cid: "facebook-logo"
  },
  {
    filename: "instagram-logo.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/instagram-logo.png`,
    cid: "instagram-logo"
  },
  {
    filename: "youtube-logo.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/youtube-logo.png`,
    cid: "youtube-logo"
  },
  {
    filename: "tiktok.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/tiktok.png`,
    cid: "tiktok"
  },
  {
    filename: "linkedin.png",
    path: `${dev ? "http://localhost:3003" : "https://vzdelanibudoucnosti.cz"}/images/linkedin.png`,
    cid: "linkedin"
  }
]
